/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { logmessage } from 'projects/icemedx-lib/src/models/system/logmessage';

export class LogReport extends IceEntity {
    LOGS: logmessage[] = [];

    constructor(msg?: logmessage) {
      super();
      if (msg != null) this.LOGS.push(msg);
    }

    gettablename(): string {
        return "LogReport";
    }

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "LOGS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "LOGS") return "LOG_MESSAGE";

        return null;
    }
}
